import OSS from "ali-oss";
import api from '@/api'
import store from '@/store'
//数据转化
function formatNumber(n) {
  n = n.toString()
  return n[1] ? n : '0' + n
}
export default {
  ossConnect(parameters) {
    return new OSS({
      region: parameters.region,
      accessKeyId: parameters.accessKeyId,
      accessKeySecret: parameters.accessKeySecret,
      bucket: parameters.bucket,
      secure: parameters.secure,
    })
  },
  //时间戳转换
  formatTime(number,format) {
    var formateArr  = ['Y','M','D','h','m','s'];
    var returnArr   = [];
    var date = new Date(number * 1000);
    returnArr.push(date.getFullYear());
    returnArr.push(formatNumber(date.getMonth() + 1));
    returnArr.push(formatNumber(date.getDate()));
    returnArr.push(formatNumber(date.getHours()));
    returnArr.push(formatNumber(date.getMinutes()));
    returnArr.push(formatNumber(date.getSeconds()));
    for (var i in returnArr)
    {
      format = format.replace(formateArr[i], returnArr[i]);
    }
    return format;
  },
  //
  formatWeekDay(index){
    let weekDays=['日','一','二','三','四','五','六']
    return weekDays[index]
  },
  logs(parent_models,models,logs,log_type){
    api.commonApi.commonIndex.logs({
      parent_models_name:parent_models,
      models_name:models,
      logs:logs,
      user_id:store.getters.getUser.uid?store.getters.getUser.uid:0,
      log_type:log_type
    })
  }
}



// WEBPACK FOOTER //
// ./src/common/models/common-models.js